import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";

// Fichas tecnicas de un modelo: pdf, excel o imagenes. Son del modelo, asi que
// se ven igual desde cualquier orden de compra que lo traiga.
// onCambio(fichas) avisa la lista nueva despues de subir o borrar.
const URL_FICHAS = process.env.REACT_APP_URL_FICHAS_TECNICAS;
const headers = () => ({ Authorization: `Bearer: ${localStorage.getItem("app_token")}` });

function FichasTecnicasModal({ abierto, cerrar, modelo, idArticulo, fichas, onCambio }) {
  const [subiendo, setSubiendo] = useState(false);

  async function sube(archivos) {
    if (!archivos.length) return;
    setSubiendo(true);
    let lista = fichas;
    for (const archivo of archivos) {
      try {
        const fd = new FormData();
        fd.append("articulo", idArticulo);
        fd.append("file", archivo);
        const r = await axios.post(URL_FICHAS, fd, { headers: headers() });
        lista = r.data || lista;
        onCambio(lista);
      } catch (error) {
        Swal.fire({ icon: "error", title: `No se pudo subir ${archivo.name}`, text: error.response?.data?.message || error.message });
        break;
      }
    }
    setSubiendo(false);
  }

  async function borra(f) {
    const conf = await Swal.fire({
      title: "¿Borrar esta ficha?", text: f.nombre, icon: "warning",
      showCancelButton: true, confirmButtonText: "Sí, borrar", cancelButtonText: "Cancelar",
    });
    if (!conf.isConfirmed) return;
    try {
      const r = await axios.delete(`${URL_FICHAS}/${idArticulo}/${f._id}`, { headers: headers() });
      onCambio(r.data || []);
    } catch (error) {
      Swal.fire({ icon: "error", title: "No se pudo borrar", text: error.response?.data?.message || error.message });
    }
  }

  return (
    <Modal isOpen={abierto} toggle={cerrar}>
      <ModalHeader toggle={cerrar}>Fichas técnicas · {modelo}</ModalHeader>
      <ModalBody>
        <p style={{ color: "#64748b", marginTop: 0, fontSize: 13 }}>
          Son del modelo: se ven en todas las órdenes que lo traen. PDF, Excel o imágenes, hasta 20 MB cada una.
        </p>
        <Table size="sm" bordered style={{ marginBottom: 12 }}>
          <tbody>
            {!fichas.length ? (
              <tr><td style={{ textAlign: "center", color: "#94a3b8" }}>Todavía no tiene fichas.</td></tr>
            ) : fichas.map((f) => (
              <tr key={f._id}>
                <td style={{ verticalAlign: "middle" }}>
                  <a href={f.url} target="_blank" rel="noopener noreferrer"><i className="fas fa-file-alt" /> {f.nombre}</a>
                  <div style={{ fontSize: 11, color: "#94a3b8" }}>{f.fecha}</div>
                </td>
                <td style={{ width: 40, textAlign: "center", verticalAlign: "middle" }}>
                  <Button size="sm" color="danger" title="Borrar la ficha" onClick={() => borra(f)}>
                    <i className="fas fa-trash" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <label className="btn btn-info btn-sm" style={{ margin: 0, cursor: subiendo ? "wait" : "pointer" }}>
          <i className="fas fa-upload" /> {subiendo ? "Subiendo..." : "Subir fichas"}
          <input type="file" multiple style={{ display: "none" }} disabled={subiendo}
            accept=".pdf,.xls,.xlsx,.doc,.docx,.csv,image/*"
            onChange={(e) => { const lista = [...(e.target.files || [])]; e.target.value = ""; sube(lista); }} />
        </label>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={cerrar}>Cerrar</Button>
      </ModalFooter>
    </Modal>
  );
}

export default FichasTecnicasModal;
